<template>
  <v-row column wrap>
    <v-col cols="12">
      <v-form ref="form">
        <v-text-field
          label="Заголовок"
          :rules="[(v) => !!v || 'Это поле обязательно']"
          v-model="prog.title"
          name="title"
        >
        </v-text-field>
        <ckeditor
          :editor="ckeditor"
          v-model="prog.description"
          :config="ckConfig"
          type="classic"
          name="description"
        >
        </ckeditor>
        <input type="text" name="id" v-model="prog.id" style="display: none" />
        <v-btn color="secondary" @click="save">{{ submitButton }}</v-btn>
        <v-btn color="warning" v-show="prog.id > 0" @click="prog = { ...defaultProg }"
          >Очистить</v-btn
        >
      </v-form>
    </v-col>

    <v-col cols="12" v-show="programList">
      <list-view
        :with-sites="false"
        :color="'#538DCB'"
        :items="programList"
        :items-name="'party/program'"
        :description-field="'description'"
        :title-field="'title'"
        @remove-item="updateData"
        @item-click="itemClick"
      ></list-view>
    </v-col>
  </v-row>
</template>

<script>
import ckeditorMixin from '@/mixins/ckeditor'
import ListView from '@/components/ListView'

export default {
  name: 'history',
  components: { ListView },
  mixins: [ckeditorMixin],
  data() {
    return {
      programList: [],
      currentProgram: {},
      prog: { title: '', description: '', sort: 0, id: -1 },
      defaultProg: { title: '', description: '', sort: 0, id: -1 },
    }
  },
  computed: {
    submitButton() {
      return this.prog.id > 0 ? 'Сохранить' : 'Добавить'
    },
  },
  mounted() {
    this.updateData()
  },
  methods: {
    itemClick(e) {
      this.prog = { ...e }
    },
    updateData() {
      this.axios({ url: '/v1/party/program', method: 'get' })
        .then((resp) => {
          this.programList = resp.data
        })
        .catch((err) => {
          this.$log.error(err)
          this.showSnackbar(err.response ? err.response.data : err, 'error')
        })
    },
    save() {
      if (!this.$refs.form.validate()) {
        return
      }
      const url = this.prog.id > 0 ? `/v1/party/program/${this.prog.id}` : '/v1/party/program'
      this.axios({
        url: url,
        method: this.prog.id > 0 ? 'patch' : 'post',
        data: this.prog,
      })
        .then((resp) => {
          this.prog = { title: '', description: '', sort: 0, id: -1 }
          this.updateData()
          this.showSnackbar('Сохранено', 'green')
          this.$refs.form.resetValidation()
        })
        .catch((err) => {
          this.showSnackbar(err.response ? err.response.data : err, 'error')
        })
    },
    deleteItem(id) {
      this.axios({ url: `/v1/party/program/${id}`, method: 'delete' })
        .then((resp) => {
          this.showSnackbar('Удалено', 'green')
          this.updateData()
        })
        .catch((err) => {
          this.$log.error(err)
          this.showSnackbar(err.response ? err.response.data : err, 'error')
        })
    },
    updateSort(id, sort) {
      this.axios({ url: `/v1/party/program/${id}/sort`, method: 'post', data: { sort: sort } })
        .then((resp) => {
          this.$log.debug('updated sort')
        })
        .catch((err) => {
          this.$log.error(err)
          this.showSnackbar(err.response ? err.response.data : err, 'error')
        })
    },
    moveUp(i) {
      const programList = [...this.programList]
      programList.swap(i, i - 1)
      for (let i = 0; i < programList.length; i++) {
        programList[i].sort = i
        this.updateSort(programList[i].id, i)
      }
      this.programList = programList
    },
    moveDown(i) {
      const programList = [...this.programList]
      programList.swap(i, i + 1)
      for (let i = 0; i < programList.length; i++) {
        programList[i].sort = i
        this.updateSort(programList[i].id, i)
      }
      this.programList = programList
    },
  },
}
</script>

<style scoped lang="scss">
.item {
  margin: 20px;
}

.item__description {
  border-left: 2px solid $main_blue;
  padding-left: 10px;
}
</style>
